import React from 'react';

import { ADMIN_CUSTOMIZE_NAVIGATION } from '@confluence/named-routes/entry-points/routes.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';

export const AdminColorSchemeRoute = () => <Redirection name={ADMIN_CUSTOMIZE_NAVIGATION.name} />;

AdminColorSchemeRoute.NAVIGATION_PARAMS = () => false;
